import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { CoreModule } from '../core/core.module';
import { DictionaryNgrxModule } from '@teamfoster/sdk/dictionary-ngrx';
import { TextUtilityModule } from '@teamfoster/sdk/text-utility';
import { DynamicFormModule } from '@teamfoster/dynamic-forms';
import { FormRadioListComponent } from './components/form-radio-list/form-radio-list.component';
import { FormInputV2Component } from './components/form-input-v2/form-input-v2.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { FormConnectedAddressComponent } from './components/form-connected-address/form-connected-address.component';
import { AccountModule } from '../account/account.module';
import { RouterModule } from '@angular/router';
import { MatCheckboxModule } from '@angular/material/checkbox';

// extends dynamic form fields
export const formControls = {
  'radio-list': FormRadioListComponent,
  'NIEUW': FormInputV2Component,
  'connected-address': FormConnectedAddressComponent,
};

@NgModule({
  declarations: [FormRadioListComponent, FormInputV2Component, FormConnectedAddressComponent],
  imports: [
    CommonModule,
    CoreModule,
    ReactiveFormsModule,
    DictionaryNgrxModule,
    DynamicFormModule,
    TextUtilityModule,
    MatInputModule,
    MatFormFieldModule,
    MatCheckboxModule,
    MatIconModule,
    RouterModule,
    AccountModule,
  ],
})
export class FormModule {}
